import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { DocumentTemplateApi } from "./documentTemplatesApi";
import { DocumentTypeApi } from "./documentTypesApi";

const create = (
  courseId: number,
  request: {
    templateId: number;
    templatePageId: number;
    name: string;
    placeholders: { placeholderId: number; placeholderValue: string }[];
  }
): AxiosPromise => {
  return api.post(endpoints.COURSE_DOCUMENTS.CREATE(courseId), request);
};
const deleteDocument = (courseId: number, courseDocumentId: number): AxiosPromise => {
  return api.delete(endpoints.COURSE_DOCUMENTS.DELETE(courseId, courseDocumentId));
};

const update = (
  courseId: number,
  courseDocumentId: number,
  request: {
    templateId: number;
    templatePageId: number;
    name: string;
    placeholders: { placeholderId: number; placeholderValue: string }[];
  }
): AxiosPromise => {
  return api.put(endpoints.COURSE_DOCUMENTS.UPDATE(courseId, courseDocumentId), request);
};

const fetch = (courseId: number): AxiosPromise<CourseDocumentApi[]> => {
  return api.get<CourseDocumentApi[]>(endpoints.COURSE_DOCUMENTS.GET(courseId));
};

const fetchById = (courseId: number, courseDocumentId: number): AxiosPromise<CourseDocumentApi> => {
  return api.get<CourseDocumentApi>(endpoints.COURSE_DOCUMENTS.GET_BY_ID(courseId, courseDocumentId));
};

const getCourseDocumentStudents = (
  courseId: number,
  courseDocumentId: number,
  filter?: string
): AxiosPromise<CourseDocumentStudentsResponse> => {
  return api.get<CourseDocumentStudentsResponse>(
    endpoints.COURSE_DOCUMENTS.GET_STUDENTS(courseId, courseDocumentId, filter)
  );
};

const generateDocument = (courseId: number, courseDocumentId: number, body: GenerateDocumentRequest): AxiosPromise => {
  return api.post(endpoints.COURSE_DOCUMENTS.GENERATE_DOCUMENTS(courseId, courseDocumentId), body);
};
export const courseDocumentsApi = {
  create,
  fetch,
  update,
  fetchById,
  delete: deleteDocument,
  getCourseDocumentStudents,
  generateDocument,
};

/** The "Dokumenty 2.0" part of a course document: the template it is built on and its course-level pdfme values. */
export interface CourseDocumentV2Info {
  templateV2Id: number;
  templateName: string;
  type: DocumentTypeApi;
  /** A JSON-ENCODED STRING (an object of strings), not a nested object: JSON.parse it. */
  valuesJson: string;
}

/**
 * A course document of either version. A 1.0 document (`version` 1) has `template` and placeholders and no `v2`; a 2.0
 * document (`version` 2) has `v2` and a null `template`, so never read `template` without checking.
 */
export interface CourseDocumentApi {
  id: number;
  name: string;
  template: DocumentTemplateApi | null;
  placeholders: {
    documentTemplatePlaceholderId: number;
    placeholderName: string;
    placeholderValue: string;
  }[];
  courseId: number;
  version: 1 | 2;
  v2: CourseDocumentV2Info | null;
}

export interface CourseDocumentStudentsResponse {
  documentTemplate: DocumentTemplateApi;
  students: {
    id: number;
    firstName: string;
    surname: string;
    email: string;
    placeholders: {
      documentPlaceholderId: number;
      placeholderName: string;
      placeholderValue: string;
    }[];
  }[];
}

export interface GenerateDocumentRequest {
  id: number;
  firstName: string;
  surname: string;
  email: string;
  placeholders: {
    documentPlaceholderId: number;
    placeholderValue: string;
  }[];
}
